// CSP's auth pages only send the visitor back to SLP when ?redirect=slp is on the
// URL. The login URL carried it but the signup URL did not, so anyone who created
// an account landed on CSP with no way back. Applied here rather than baked into
// the literals so the REACT_APP_CSP_*_URL overrides get it too. Idempotent, and
// it forces redirect=slp even if a configured URL names a different target --
// these two links exist to bring the visitor back here.
const withSlpRedirect = (url: string): string => {
  try {
    const parsed = new URL(url);
    parsed.searchParams.set('redirect', 'slp');
    return parsed.toString();
  } catch {
    // Relative or malformed value — leave it alone rather than break the link.
    return url;
  }
};

const config = {
  locale: window.localStorage && window.localStorage.getItem ? window.localStorage.getItem('locale') : 'en',
  IS_CONSOLE_ALLOWED: true,
  API_BASE_URL: process.env.REACT_APP_API_BASE_URL,
  // Must match the API's XSRF_COOKIE_NAME (staging uses its own name).
  xsrfCookieName: process.env.REACT_APP_XSRF_COOKIE_NAME || 'XSRF-TOKEN',
  environment: process.env.REACT_APP_ENV || process.env.NODE_ENV,
  version: '2024-06-28-1005',
  socketURL: process.env.REACT_APP_SOCKET_URL || '',
  MAX_TICKET_CHARACTER_LIMIT: process.env.MAX_TICKET_CHARACTER_LIMIT || 250,
  MIN_TICKET_CHARACTER_LIMIT: process.env.MIN_TICKET_CHARACTER_LIMIT || 50,
  csp_url: process.env.REACT_APP_CSP_URL || 'https://californiaspecies.com',
  csp_pricing_url: process.env.REACT_APP_CSP_PRICING_URL || 'https://californiaspecies.com/pricing',
  csp_login_url: withSlpRedirect(
    process.env.REACT_APP_CSP_LOGIN_URL || 'https://californiaspecies.com/account/login'
  ),
  csp_signup_url: withSlpRedirect(
    process.env.REACT_APP_CSP_SIGNUP_URL || 'https://californiaspecies.com/account/signup'
  ),
};
if (process.env.NODE_ENV === 'production') {
  config.IS_CONSOLE_ALLOWED = false;
}

export default config;
